export default "__VITE_ASSET__auAncWU7__"